import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { MapPin, Calendar, Users, Sparkles } from 'lucide-react';
export const EventDetailsSection = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section id="details" ref={sectionRef} className="py-20 md:py-28 bg-black relative overflow-hidden" style={{
    opacity
  }} data-id="element-1125">
      <div className="absolute inset-0 bg-gradient-to-b from-amber-950/10 to-black/60 z-0" data-id="element-1126"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-1127">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-24" data-id="element-1128">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-1129">
            Essential Information
          </p>
          <h2 className="font-serif text-5xl md:text-7xl text-white mb-8" data-id="element-1130">
            EVENT
            <br data-id="element-1131" />
            <span className="text-amber-400" data-id="element-1132">DETAILS</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto" data-id="element-1133"></div>
        </motion.div>
        <div className="max-w-6xl mx-auto" data-id="element-1134">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16" data-id="element-1135">
            {/* Venue Card */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-1136">
              <div className="relative" data-id="element-1137">
                <div className="aspect-video relative overflow-hidden mb-8 rounded-lg" data-id="element-1138">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kppHXez1XGBnRYW5bwUDVX/illumiarium.png" alt="Illuminarium Venue" className="w-full h-full object-contain bg-black" data-id="element-1139" />
                </div>
                <div className="space-y-8" data-id="element-1140">
                  <div className="flex items-start" data-id="element-1141">
                    <MapPin className="w-6 h-6 text-amber-400 mr-4 flex-shrink-0 mt-1" data-id="element-1142" />
                    <div data-id="element-1143">
                      <h4 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-1144">
                        Venue
                      </h4>
                      <p className="text-white/80 font-light leading-relaxed" data-id="element-1145">
                        Illuminarium Toronto
                        <br data-id="element-1146" />
                        123 Experience Drive
                        <br data-id="element-1147" />
                        Toronto, ON M5V 2K4
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-1148">
                    <Calendar className="w-6 h-6 text-amber-400 mr-4 flex-shrink-0 mt-1" data-id="element-1149" />
                    <div data-id="element-1150">
                      <h4 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-1151">
                        Dates
                      </h4>
                      <p className="text-white/80 font-light leading-relaxed" data-id="element-1152">
                        Summer 2026
                        <br data-id="element-1153" />
                        Doors open at 6:00 PM
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
            {/* Details Card */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="flex flex-col justify-between space-y-8" data-id="element-1154">
              <div className="space-y-8" data-id="element-1155">
                <div className="flex items-start" data-id="element-1156">
                  <Users className="w-6 h-6 text-amber-400 mr-4 flex-shrink-0 mt-1" data-id="element-1157" />
                  <div data-id="element-1158">
                    <h4 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-1159">
                      Capacity
                    </h4>
                    <p className="text-white/80 font-light leading-relaxed" data-id="element-1160">
                      Limited & exclusive seating
                      <br data-id="element-1161" />
                      Only 120 guests per evening
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-1162">
                  <Sparkles className="w-6 h-6 text-amber-400 mr-4 flex-shrink-0 mt-1" data-id="element-1163" />
                  <div data-id="element-1164">
                    <h4 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-1165">
                      Format
                    </h4>
                    <p className="text-white/80 font-light leading-relaxed" data-id="element-1166">
                      Sikh Foundation Centennial Gala experience
                      <br data-id="element-1167" />
                      Immersive dining and cultural showcase
                    </p>
                  </div>
                </div>
              </div>
              <div className="border border-amber-400/30 p-8 bg-black/40" data-id="element-1168">
                <h3 className="font-serif text-3xl text-amber-400 mb-4" data-id="element-1169">
                  Summer 2026
                </h3>
                <p className="text-white/70 font-light mb-4 leading-relaxed" data-id="element-1170">
                  The exclusive experience takes place Summer 2026. All ticket
                  holders receive admission to this premiere experience.
                </p>
                <div className="w-full h-px bg-white/10 my-6" data-id="element-1171"></div>
                <h4 className="text-xl text-amber-400 font-light mb-3" data-id="element-1172">
                  Monthly Experiences
                </h4>
                <p className="text-white/70 font-light mb-6 leading-relaxed" data-id="element-1173">
                  Your ticket also grants access to one monthly experience
                  between May and December 2026. Choose your preferred date when
                  finalizing your reservation.
                </p>
                <div className="flex justify-between items-center pt-4 border-t border-white/10" data-id="element-1174">
                  <span className="text-amber-400 font-light tracking-wider" data-id="element-1175">
                    Summer 2026
                  </span>
                  <span className="text-white/60 text-sm tracking-wider uppercase" data-id="element-1176">
                    Premiere Event
                  </span>
                </div>
                <div className="flex justify-between items-center pt-3" data-id="element-1177">
                  <span className="text-amber-400 font-light tracking-wider" data-id="element-1178">
                    May - Dec 2026
                  </span>
                  <span className="text-white/60 text-sm tracking-wider uppercase" data-id="element-1179">
                    Monthly Access
                  </span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
        {/* Bottom Quote */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-center mt-24" data-id="element-1180">
          <p className="text-xl text-white/70 italic font-light max-w-3xl mx-auto" data-id="element-1181">
            "Mark your calendars for two unforgettable evenings of history,
            culture, and culinary excellence."
          </p>
        </motion.div>
      </div>
    </motion.section>;
};